
export default {
    name: 'taux-analyses',
    components: {},
    props: [],
    data() {
        return {

        }
    },
    
    computed: {

    },

    mounted() {

    },

    methods: {

    }
}